import { render, staticRenderFns } from "./product_lg.vue?vue&type=template&id=26a1903a"
import script from "./product_lg.vue?vue&type=script&lang=js"
export * from "./product_lg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Availability: require('/home/ubuntu/containers/hermes_eshop/components/core/availability.vue').default})
